import { Level, LogHandler } from 'simple-logging-lib';
import { captureException } from '../utils/sentryAPI';
import { isServiceError } from './isServiceError';
import { ErrorBoundaryError } from './ErrorBoundaryError';
const formatServiceError = error => {
  if (!isServiceError(error)) {
    return error;
  }
  const {
    message,
    error: {
      status,
      statusText,
      responseJSON
    },
    cause,
    stack
  } = error;
  return {
    message,
    status,
    statusText,
    responseJSON,
    cause,
    stack
  };
};
export class ErrorLogHandler extends LogHandler {
  constructor(...args) {
    super(...args);
    this.level = Level.ERROR;
  }
  publish(record) {
    if (!this.isLoggable(record)) {
      return;
    }
    const {
      loggerName,
      messages
    } = record;
    console.error(`%c[${loggerName}]`, 'color: #444; font-weight: bold;', ...messages);
    const [maybeError, options] = messages;
    if (maybeError instanceof Error) {
      this.reportError(maybeError, options);
    }
  }
  reportError(error, options = {}) {
    const {
      cause
    } = error;
    const extra = {};
    const tags = {};
    if (error instanceof ErrorBoundaryError) {
      tags.errorBoundaryName = error.options.boundaryName;
    }
    if (isServiceError(cause)) {
      extra.cause = formatServiceError(cause);
    } else if (cause instanceof Error) {
      extra.cause = {
        message: cause.message,
        stack: cause.stack,
        error: cause
      };
    }
    captureException(error, Object.assign({}, options, {
      extra: Object.assign({}, options.extra, extra),
      tags
    }));
  }
}